import React, { Fragment } from 'react';
import cn from 'classnames';
import { NavLink } from 'react-router-dom';
import Icon from '../icon/icon';
import styles from './styles.css';

const routes = [
  {
    text: 'Home',
    path: '/',
    exact: true,
    icon: 'home'
  },
  {
    text: 'Agenda',
    path: '/agenda',
    icon: 'agenda'
  },
  {
    text: 'Lots',
    path: '/lots',
    icon: 'stove-pot'
  },
  {
    text: 'Tanks',
    path: '/tanks',
    icon: 'tank'
  },
  {
    text: 'Reports',
    path: '/reports',
    icon: 'reports'
  },
  {
    text: 'Customers',
    path: '/customers',
    icon: 'customers'
  },
  {
    text: 'Ingredients',
    path: '/ingredients',
    icon: 'ingredients'
  },
  {
    text: 'Products',
    path: '/products',
    icon: 'chef-hat'
  },
  {
    text: 'Vessels',
    path: '/vessels',
    icon: 'keg'
  },
  {
    text: 'Settings',
    path: '/settings',
    icon: 'cogs'
  }
];

const SideNav = ({ isOpen, onClose }) => {
  const classes = cn(styles.container, {
    [styles.isOpen]: isOpen
  });
  return (
    <Fragment>
      <nav className={classes}>
        <ul className="list flex flex-column mv3 pl3">
          {routes.map(r => (
            <li key={r.text} className={`pa0 ma0`}>
              <NavLink
                exact={r.exact}
                to={r.path}
                activeClassName={`${styles.active} strong`}
                className={`text self-center flex items-center mv3 ${styles.link}`}
              >
                {r.icon && <Icon icon={r.icon} className={`f4 mr3 ${styles.icon}`} />}
                {r.text}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>
      {isOpen && (
        <Icon
          icon="close"
          className={`stroke-white pa2 ml2 absolute db dn-l pointer ${styles.close}`}
          onClick={onClose}
        />
      )}
      <div className={`${styles.overlay} ${isOpen ? styles.visible : ''} pointer`} onClick={onClose} />
    </Fragment>
  );
};

export default SideNav;



// WEBPACK FOOTER //
// ./src/components/sideNav/sideNav.jsx